import { render } from "./app-form-textarea.vue?vue&type=template&id=d46aee4a"
import script from "./app-form-textarea.vue?vue&type=script&lang=js"
export * from "./app-form-textarea.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/form/app-form-textarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d46aee4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d46aee4a', __exports__)) {
    console.log('reload')
    api.reload('d46aee4a', __exports__)
  }
  
  module.hot.accept("./app-form-textarea.vue?vue&type=template&id=d46aee4a", () => {
    console.log('re-render')
    api.rerender('d46aee4a', render)
  })

}


export default __exports__